import React, { useEffect } from 'react';
import { useGlobalContext } from "../context/GlobalContext";

export const VisualId = () => {
  const { setLightTheme, setNested } = useGlobalContext()

  useEffect(() => {
    setLightTheme(true);
    setNested(true)
  }, [])


  return (
    <React.Fragment>
      <div className="m-visualid">
        <div className="m-visualid__tab-container">
          <div className="m-visualid__tab">
            <img className="lazyload m-visualid__cover" src={require('../static/images/graphics/jazz01.png')} alt="jazzjamboree id" />
          </div>
          <div className="m-visualid__tab">
            <img className="lazyload m-visualid__cover" src={require('../static/images/graphics/jazz02.png')} alt="jazzjamboree id" />
          </div>
          <div className="m-visualid__tab">
            <img className="lazyload m-visualid__cover" src={require('../static/images/graphics/sztuk01.png')} alt="festival sztuk id" />
          </div>
          <div className="m-visualid__tab">
            <img className="lazyload m-visualid__cover" src={require('../static/images/graphics/sztuk02.png')} alt="festival sztuk id" />
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}